/**
 * Read-only helpers for displaying Memory Book team photos on public routes.
 * Focal positioning mirrors EventMemoryBook (teamPhotoObjectPosition without live team-doc focal map).
 */

const DEFAULT_TEAM_PHOTO_FOCUS_Y = 18;

function clampNumber(n, min, max) {
  const x = typeof n === 'number' ? n : Number.parseFloat(n);
  if (!Number.isFinite(x)) return min;
  return Math.min(max, Math.max(min, x));
}

function clamp01(n) {
  const x = typeof n === 'number' ? n : Number.parseFloat(n);
  if (!Number.isFinite(x)) return 0;
  return Math.min(1, Math.max(0, x));
}

function normalizeFocalPoint(fp) {
  if (!fp || typeof fp !== 'object') return null;
  const x = clamp01(fp.x);
  const y = clamp01(fp.y);
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  return { x, y };
}

function legacyTeamPhotoFocusY(teamId, memoryMeta) {
  const raw = memoryMeta?.teamPhotoFocus?.[teamId];
  return clampNumber(raw, 0, 100);
}

/** @param {Record<string, unknown>|null|undefined} memoryMeta - eventMemoryMeta doc data */
export function buildTeamPosterUrlMap(memoryMeta) {
  const arr = Array.isArray(memoryMeta?.teamPhotos) ? memoryMeta.teamPhotos : [];
  const map = {};
  arr.forEach((e) => {
    if (e?.teamId && e?.posterUrl) map[e.teamId] = e.posterUrl;
  });
  return map;
}

/** @param {Record<string, unknown>|null|undefined} memoryMeta - eventMemoryMeta doc data */
export function buildTeamPhotoUrlMap(memoryMeta) {
  const arr = Array.isArray(memoryMeta?.teamPhotos) ? memoryMeta.teamPhotos : [];
  const map = {};
  arr.forEach((e) => {
    if (e?.teamId && e?.url) map[e.teamId] = e.url;
  });
  return map;
}

/**
 * @param {string} teamId
 * @param {Record<string, unknown>|null|undefined} memoryMeta
 * @returns {string} CSS object-position value
 */
export function teamPhotoCssObjectPosition(teamId, memoryMeta) {
  const metaFp = teamId ? normalizeFocalPoint(memoryMeta?.teamPhotoFocalPoints?.[teamId]) : null;
  if (metaFp) return `${(metaFp.x * 100).toFixed(2)}% ${(metaFp.y * 100).toFixed(2)}%`;

  const y = teamId ? legacyTeamPhotoFocusY(teamId, memoryMeta) : DEFAULT_TEAM_PHOTO_FOCUS_Y;
  const yy = Number.isFinite(y) ? y : DEFAULT_TEAM_PHOTO_FOCUS_Y;
  return `50% ${yy}%`;
}
